import * as React from "react";
import { styled } from "styled-components";
const StyledContainer = styled.div `
  width: 100%;
  padding: 1rem;
`;
export const Container = React.memo(({ children, ...props }) => (React.createElement(StyledContainer, { ...props }, children)));
Container.displayName = "Container";
export default Container;
//# sourceMappingURL=index.js.map